import "./categoires.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _Link = _interopRequireDefault(require("../Link"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _component = require("../../_utils/component.js");

var _vueNormalizeComponent = _interopRequireDefault(require("../../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('template-categorys'),
  components: {
    GDLink: _Link.default,
    Icon: _Icon.default
  },
  mixins: [_component.componentMixin],
  props: {
    categories: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      tabKey: 1
    };
  },

  methods: {
    changeKey(key) {
      this.tabKey = key;
    },

    onClick(item) {
      this.$emit('click', item);
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    class: _vm.bem()
  }, _vm._l(_vm.categories, function (category, i) {
    return _c("div", {
      key: i,
      class: _vm.bem("category")
    }, [_c("GDLink", {
      class: _vm.bem("title"),
      attrs: {
        url: {
          path: "/templates/cid-sid" + category.id
        }
      },
      on: {
        click: function click($event) {
          return _vm.onClick(category);
        }
      }
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _vm._l(category.children.slice(0, 6), function (item, i) {
      return _c("div", {
        key: i,
        class: _vm.bem("item")
      }, [_c("GDLink", {
        attrs: {
          url: {
            path: "/templates/cid" + item.id + "-sid" + category.id
          }
        },
        on: {
          click: function click($event) {
            return _vm.onClick(item);
          }
        }
      }, [_vm._v("\n                " + _vm._s(item.name) + "\n                "), item.name === "手机海报" ? _c("span", {
        class: _vm.bem("hot")
      }, [_c("em", [_vm._v("HOT")])]) : _vm._e(), _vm._v(" "), item.name === "GIF动图" ? _c("span", {
        class: _vm.bem("new")
      }, [_c("em", [_vm._v("NEW")])]) : _vm._e()])], 1);
    }), _vm._v(" "), category.children.length > 6 ? _c("div", {
      class: _vm.bem("item")
    }, [_c("GDLink", {
      attrs: {
        url: {
          path: "/templates/sid" + category.id
        }
      },
      on: {
        click: function click($event) {
          return _vm.onClick();
        }
      }
    }, [_vm._v("\n                更多\n                "), _c("Icon", {
      attrs: {
        name: "arrow-right"
      }
    })], 1)], 1) : _vm._e()], 2);
  }), 0);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;